<template>
  <v-btn
    flat
    @click.exact="$emit('click')"
    @click.native="$emit('native')"
  >
    {{ buttonText }}
  </v-btn>
</template>
<script>
export default {
  name: 'HeaderButton',
  props: {
    buttonText: {
      type: String,
      required: true,
    },
  },

}
</script>
<style lang="stylus" scoped>

</style>
